import Utils from "./services/utils-service.js";
import FormInputs from "./services/inputs-service.js";
import Funnel from "./services/funnel-service";

export default {
    methods: {
        exec: function (e, input, args = {}) {
            const isFxnEmpty = Utils.isEmpty(input.fxn);
            let fi = null;
            if (!isFxnEmpty) {
                fi = new FormInputs({ ctx: this.$store, router: this.$router });

                args = this.mergeArgsFromElement(e, input, args);

                if (args && args.validate) {
                    fi.isValid(this.input);
                }
            }

            if (!args.skipUpdate) {
                //TODO: Review and possible wrap in a condition check using args.
                this.updateValue(e);
            }

            if (!Utils.isEmpty(fi)) {
                fi.eventHandler(e, input);
            }
        },
        updateValue: function (e) {
            if (!this.isValueUpdateSupressedOnEvent(e)) {
                if (e.target.value !== undefined && !Utils.isEmpty(this.input.uid)) {
                    this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: e.target.value });
                } else {
                    console.log('Input uid is missing or value is undefined.');
                }
            }
        },
        isTruthy: function (val) {
            return Utils.isTruthy(val);
        },
        setDisabled(disabled) {
            return Utils.isTruthy(disabled);
        },
        mergeArgsFromElement(e, input, args) {
            if (!Utils.isEmpty(input.fxn_args)) {
                if (!Utils.isObjEmpty(input.fxn_args[input.fxn[e.type]])) {
                    console.log(e.type);
                    args = { ...args, ...input.fxn_args[input.fxn[e.type]] };
                }
            }
            return args
        },
        isValueUpdateSupressedOnEvent(e) {
            let decline = false;
            if (!Utils.isObjEmpty(this.input.supress_update_on_event) && !Utils.isObjEmpty(this.input.supress_update_on_event[e.type])) {
                const rEv = this.input.supress_update_on_event[e.type];
                if (this.input[rEv.prop] == rEv.eq) {
                    console.log(`unregistered event ${e.type} for input ${this.input.uid} was declined for update.`);
                    decline = true;
                }
            }
            return decline;
        },
        computedLabel: function (obj) {
            let labelText = obj.label;
            if (!Utils.isObjEmpty(obj.labels)) {
                const fs = new Funnel({ ctx: this.$store, router: this.$router });
                for (const label of obj.labels) {
                    if (fs.display(label)) {
                        labelText = label.text;
                    }
                }
            }
            return labelText;
        },
        isVisible: function (input) {
            let visible = false;
            if (!Utils.isObjEmpty(input)) {
                const fs = new Funnel({ ctx: this.$store, router: this.$router });
                visible = fs.display(input) && !Utils.isTruthy(input.hidden);
            }
            return visible;
        },
        parseHtml: function (html) {
            if (!html) {
                return
            }
            return html.replace(/{{(.+?)}}/g, (_, g) => {
                console.log("PARSE HTML:: " + this[g.trim()]);
                return this[g.trim()];
            });
        },
        handleIIFE() {
            var $self = this;
            if (!Utils.isObjEmpty(this.input.fxn) && !Utils.isEmpty(this.input.fxn.onLoad)) {
                this.$nextTick(function () {
                    $self.execOnLoad();
                });
            }
        },
        execOnLoad() {
            try {
                const el = this.input.fxn.onLoad;
                eval(`this.fs.${el}()`);
            } catch (err) {
                let eMsg = `Error:- mixin execOnLoad: ${err}. calling non-existent function`;
                console.log(eMsg);
                //throwError(new Error(eMsg), { "exec_onLoad": el, "input": JSON.stringify(this.input) });
            }
        },
        initModal(e, mdlUid) {
            const fs = new Funnel({ ctx: this.$store, router: this.$router });
            fs.toggleModal(mdlUid);
            e.preventDefault();
        }
    }
}